<template>
  <div>
    <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }">
      <div id="myCals">
        <div class="title_">
          <div class="cutleft_">保费试算</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <div class="form_item">
              <a-form-item :label-col="{ span: 16 }" class="blod" label="工程造价(单位:元)">
                <a-input style="width: 300px" :disabled="disabledAll" v-model="countData.projectamount" @change="value => changeData(value.target.value, 'projectamount')" placeholder="工程造价" />
              </a-form-item>
            </div>
            <div class="form_item">
              <a-form-item :label-col="{ span: 16 }" class="blod" label="选择第三者责任限额" :wrapper-col="{ span: 8 }">
                <a-select :disabled="disabledAll" v-model="countData.plan" placeholder="选择第三者责任限额" style="width: 300px" class="select_" @change="value => changeData(value, 'plan')">
                  <a-select-option v-for="(item, index) in planList" :key="index" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="form_item ml20">
              <a-form-item :label-col="{ span: 16 }" label="累计赔偿额度">
                <a-input disabled style="width: 300px" :value="planList[planIdx].money1" placeholder="累计赔偿额度" />
              </a-form-item>
            </div>
            <div class="form_item ml20">
              <a-form-item :label-col="{ span: 16 }" label="每次赔偿额度">
                <a-input disabled style="width: 300px" :value="planList[planIdx].money2" placeholder="每次赔偿额度" />
              </a-form-item>
            </div>
            <div class="form_item ml20">
              <a-form-item :label-col="{ span: 16 }" label="每人赔偿额度">
                <a-input disabled style="width: 300px" :value="planList[planIdx].money3" placeholder="每人赔偿额度" />
              </a-form-item>
            </div>
            <div class="form_item ml20">
              <a-form-item :label-col="{ span: 16 }" label="每次事故财产损失赔偿限额">
                <a-input disabled style="width: 300px" :value="planList[planIdx].money4" placeholder="每次事故财产损失赔偿限额" />
              </a-form-item>
            </div>
            <div class="form_item">
              <label style="font-weight: 600">附加雇主责任扩展</label>
              <div class="right_">
                <a-select :disabled="disabledAll" v-model="countData.occupationcodesh" :label-col="{ span: 15 }" placeholder="请选择附加雇主责任扩展" style="width: 300px" class="select_" @change="value => changeData(value, 'occupationcodesh')">
                  <a-select-option v-for="(item, index) in deshOptions" :key="item.value + 'desc' + index" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
              </div>
            </div>
            <div class="form_item ml20" style="margin-top: 25px">
              <a-form-item :label-col="{ span: 16 }" label="每次事故限额">
                <a-input disabled style="width: 300px" :value="deshOptions[deshIdx].money1" placeholder="每次事故限额" />
              </a-form-item>
            </div>
            <div class="form_item ml20">
              <a-form-item :label-col="{ span: 16 }" label="每人死亡伤残赔偿限额">
                <a-input disabled style="width: 300px" :value="deshOptions[deshIdx].money2" placeholder="每人死亡伤残赔偿限额" />
              </a-form-item>
            </div>
            <div class="form_item ml20">
              <a-form-item :label-col="{ span: 16 }" label="每人医疗费用赔偿限额">
                <a-input disabled style="width: 300px" :value="deshOptions[deshIdx].money3" placeholder="每人医疗费用赔偿限额" />
              </a-form-item>
            </div>
            <p class="p-header">可附加方案</p>
            <div class="form_item ml20">
              <label>震动、移动或减弱支撑扩展条款</label>
              <div class="right_">
                <a-select :disabled="disabledAll" :label-col="{ span: 15 }" placeholder="请选择震动、移动或减弱支撑扩展条款" style="width: 300px" class="select_" v-model="countData.zdyd" @change="value => changeData(value, 'zdyd')">
                  <a-select-option v-for="(item, index) in baseOptions" :key="item.value + 'zdyd' + index" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
                <span class="redText">加费20%</span>
              </div>
            </div>
            <div class="form_item ml20">
              <label>广告及装饰装置责任条款</label>
              <div class="right_">
                <a-select :disabled="disabledAll" :label-col="{ span: 15 }" placeholder="请选择广告及装饰装置责任条款" style="width: 300px" class="select_" v-model="countData.ggzs" @change="value => changeData(value, 'ggzs')">
                  <a-select-option v-for="(item, index) in baseOptions" :key="item.value + 'ggzs' + index" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
                <span class="redText">加费20%</span>
              </div>
            </div>
            <div class="form_item ml20">
              <label>放弃代位追偿权利条款</label>
              <div class="right_">
                <a-select :disabled="disabledAll" :label-col="{ span: 15 }" placeholder="请选择放弃代位追偿权利条款" style="width: 300px" class="select_" v-model="countData.fqdw" @change="value => changeData(value, 'fqdw')">
                  <a-select-option v-for="(item, index) in baseOptions" :key="item.value + 'fqdw' + index" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
                <span class="redText">加费20%</span>
              </div>
            </div>
            <div class="form_item ml20">
              <label>临时保护措施条款</label>
              <div class="right_">
                <a-select :disabled="disabledAll" :label-col="{ span: 15 }" placeholder="请选择临时保护措施条款" style="width: 300px" class="select_" v-model="countData.lsbh" @change="value => changeData(value, 'lsbh')">
                  <a-select-option v-for="(item, index) in baseOptions" :key="item.value + 'lsbh' + index" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
                <span class="redText">加费20%</span>
              </div>
            </div>
            <div class="form_item ml20">
              <label>建筑物变动条款 </label>
              <div class="right_">
                <a-select :disabled="disabledAll" :label-col="{ span: 15 }" placeholder="请选择建筑物变动条款" style="width: 300px" class="select_" v-model="countData.jzw" @change="value => changeData(value, 'jzw')">
                  <a-select-option v-for="(item, index) in baseOptions" :key="item.value + 'jzw' + index" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
                <span class="redText">加费20%</span>
              </div>
            </div>
            <div class="form_item ml20">
              <label>清理费用扩展条款</label>
              <div class="right_">
                <a-select :disabled="disabledAll" :label-col="{ span: 15 }" placeholder="请选择清理费用扩展条款" style="width: 300px" class="select_" v-model="countData.qlf" @change="value => changeData(value, 'qlf')">
                  <a-select-option v-for="(item, index) in baseOptions" :key="item.value + 'qlf' + index" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
                <span class="redText">加费20%</span>
              </div>
            </div>
            <div class="form_item ml20">
              <label>保证期第三者责任条款</label>
              <div class="right_">
                <a-select :disabled="disabledAll" :label-col="{ span: 15 }" placeholder="请选择保证期第三者责任条款" style="width: 300px" class="select_" v-model="countData.bzq" @change="value => changeData(value, 'bzq')">
                  <a-select-option v-for="(item, index) in baseOptions" :key="item.value + 'bzq' + index" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
                <span class="redText">无需加费</span>
              </div>
            </div>
            <div class="form_item ml20">
              <label>扩展责任保证期条款（保证期限3个月）</label>
              <div class="right_">
                <a-select :disabled="disabledAll" :label-col="{ span: 15 }" placeholder="请选择扩展责任保证期条款（保证期限3个月）" style="width: 300px" class="select_" v-model="countData.kzbzq" @change="value => changeData(value, 'kzbzq')">
                  <a-select-option v-for="(item, index) in baseOptions" :key="item.value + 'kzbzq' + index" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
                <span class="redText">无需加费</span>
              </div>
            </div>
            <div class="form_item ml20">
              <label>交叉责任扩展条款</label>
              <div class="right_">
                <a-select :disabled="disabledAll" :label-col="{ span: 15 }" placeholder="请选择交叉责任扩展条款" style="width: 300px" class="select_" v-model="countData.jczr" @change="value => changeData(value, 'jczr')">
                  <a-select-option v-for="(item, index) in baseOptions" :key="item.value + 'jczr' + index" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
                <span class="redText">无需加费</span>
              </div>
            </div>
            <div class="form_item ml20">
              <label>保险期限自动延长条款(自动延长30天）</label>
              <div class="right_">
                <a-select :disabled="disabledAll" :label-col="{ span: 15 }" placeholder="请选择保险期限自动延长条款(自动延长30天）" style="width: 300px" class="select_" v-model="countData.zdyc" @change="value => changeData(value, 'zdyc')">
                  <a-select-option v-for="(item, index) in baseOptions" :key="item.value + 'zdyc' + index" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
                <span class="redText">无需加费</span>
              </div>
            </div>
            <div class="btn_list">
              <a-button class="calBtn_" :disabled="disabledAll" type="primary" @click="countPremiumSum()">刷新试算</a-button>
              <a-button style="margin-bottom: 50px" class="calBtn_" type="primary" v-if="!agreementRead" @click="goplicy" :disabled="disabledAll">完成报价，立即投保</a-button>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_ policy_none">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ totalPremium }}</div>
          </a-col>
        </a-row>
      </div>
    </a-form>
  </div>
</template>

<script>
let DATA = require('../data').default;
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
  mixins: [riskinfoMixin],
  data() {
    return {
      data: {},
      plan: '',
      totalPremium: 0,
      occupationcodesh: '', //附加雇主责任扩展保险条款
      deshOptions: DATA.deshOptions,
      baseOptions: [
        {
          name: '附加',
          value: 1,
        },
        {
          name: '不附加',
          value: -1,
        },
      ],
      planList: DATA.plansValues, //计划列表
      countData: {
        plan: 'HAZXB1',
        projectamount: '',
        occupationcodesh: 0, //震动、移动或减弱支撑扩展条款
        zdyd: -1, //震动、移动或减弱支撑扩展条款
        ggzs: -1, //广告及装饰装置责任条款
        fqdw: -1, //放弃代位追偿权利条款
        lsbh: -1, //临时保护措施条款
        jzw: -1, //建筑物变动条款
        qlf: -1, //清理费用扩展条款
        bzq: 1, //保证期第三者责任条款
        kzbzq: 1, //扩展责任保证期条款（保证期限3个月）
        jczr: 1, //交叉责任扩展条款
        zdyc: 1, //保险期限自动延长条款(自动延长30天）
      },
    };
  },
  computed: {
    planIdx() {
      let idx = 0;
      this.planList.forEach((item, i) => {
        if (item.value == this.countData.plan) {
          idx = i;
        }
      });
      return idx;
    },

    deshIdx() {
      let idx = 0;
      this.deshOptions.forEach((item, i) => {
        if (item.value == this.countData.occupationcodesh) {
          idx = i;
        }
      });
      return idx;
    },
    // 险种的数组
    riskInfos() {
      let infos = [];
      infos = [
        {
          riskCode: '090200', //震动、移动或减弱支撑扩展条款
          dutyCode: '090200',
          amount: this.countData.zdyd,
          premiumAmt: 0,
          riskName: `震动、移动或减弱支撑扩展条款`,
          riskAmountDesc: this.countData.zdyd,
        },
        {
          riskCode: '090214', //广告及装饰装置责任条款
          dutyCode: '090214',
          amount: this.countData.ggzs,
          premiumAmt: 0,
          riskName: `医疗费用补偿`,
          riskAmountDesc: this.countData.ggzs,
        },
        {
          riskCode: '090207', //放弃代位追偿权利条款
          dutyCode: '090207',
          amount: this.countData.fqdw,
          premiumAmt: 0,
          riskName: `放弃代位追偿权利条款`,
          riskAmountDesc: this.countData.fqdw,
        },
        {
          riskCode: '090300', //临时保护措施条款
          dutyCode: '090300',
          amount: this.countData.lsbh,
          premiumAmt: 0,
          riskName: `临时保护措施条款`,
          riskAmountDesc: this.countData.lsbh,
        },
        {
          riskCode: '090367', //  建筑物变动条款
          dutyCode: '090367',
          amount: this.countData.jzw,
          premiumAmt: 0,
          riskName: `建筑物变动条款`,
          riskAmountDesc: this.countData.jzw,
        },
        {
          riskCode: '090284', //  清理费用扩展条款
          dutyCode: '090284',
          amount: this.countData.qlf,
          premiumAmt: 0,
          riskName: `清理费用扩展条款`,
          riskAmountDesc: this.countData.qlf,
        },
        {
          riskCode: '090159', //  保证期第三者责任条款
          dutyCode: '090159',
          amount: this.countData.bzq,
          premiumAmt: 0,
          riskName: `保证期第三者责任条款`,
          riskAmountDesc: this.countData.bzq,
        },
        {
          riskCode: '090104', //  扩展责任保证期条款（保证期限3个月）
          dutyCode: '090104',
          amount: this.countData.kzbzq,
          premiumAmt: 0,
          riskName: `扩展责任保证期条款（保证期限3个月）`,
          riskAmountDesc: this.countData.kzbzq,
        },
        {
          riskCode: '090102', //  交叉责任扩展条款
          dutyCode: '090102',
          amount: this.countData.jczr,
          premiumAmt: 0,
          riskName: `交叉责任扩展条款`,
          riskAmountDesc: this.countData.jczr,
        },
        {
          riskCode: '090158', //保险期限自动延长条款(自动延长30天）
          dutyCode: '090158',
          amount: this.countData.zdyc,
          premiumAmt: 0,
          riskName: `保险期限自动延长条款(自动延长30天）`,
          riskAmountDesc: this.countData.zdyc,
        },
      ];
      return infos;
    },
  },
  props: ['disabledAll'],
  created() {
    const { u, p, planCode } = this.$route.query;
    this.creator = u;
    this.productCode = p;
    this.plan = planCode;
  },
  mounted() {
    this.$bus.$on('busRiskInfos', data => {
      let obj = this.$lodash.cloneDeep(this.countData);
      
      data.riskInfos &&
        data.riskInfos.forEach(e => {
          if (e.riskCode == '090200') obj.zdyd = 1;
          if (e.riskCode == '090214') obj.ggzs = 1;
          if (e.riskCode == '090207') obj.fqdw = 1;
          if (e.riskCode == '090300') obj.lsbh = 1;
          if (e.riskCode == '090367') obj.jzw = 1;
          if (e.riskCode == '090284') obj.qlf = 1;
          if (e.riskCode == '090159') obj.bzq = 1;
          if (e.riskCode == '090104') obj.kzbzq = 1;
          if (e.riskCode == '090102') obj.jczr = 1;
          if (e.riskCode == '090158') obj.zdyc = 1;
        });
      this.countData = { ...obj };
      this.countData.plan = data.salPolicy.planCode;
      this.countData.projectamount = data.salPolicyHolder.projectamount;
      this.occupationcodesh = data.salPolicyHolder.occupationcodesh;
      this.changeData('projectamount', this.countData.projectamount, true)
    });
  },
  methods: {
    // 去投保
    goplicy() {
      this.$store.commit('setAgreement', true);
    },
    // 改变试算的数据
    changeData(value, param, init) {
      let reg = /^[1-9]\d*$/
      if (param=='projectamount'&&!reg.test(value)) {
        this.countData[param] = '';
        this.$message.error('请输入整数！');
         return
      }
      if(param=='projectamount'&&value>10000000){
         this.countData[param] = '';
         this.$message.error('工程造价不能超过1000万！');
         return
      }
      this.countData[param] = value;
      this.data = {
        riskInfos: this.riskInfos.filter(item => item.amount == 1), //险种信息
        salPolicy: {
          productCode: this.$route.query.p, //产品code
          optionalFlag: 12, //保费期限
          planCode: this.countData.plan,
        },
        salPolicyExt: {
          isworkheightinvolved: 2, //是否高空（2-否，1-是）
          occEmpVersion: this.fileCodeContent.id,
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          occupationcodesh: this.countData.occupationcodesh,
          projectamount: this.countData.projectamount, //地区系数
          stature: 2, //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [], //人数
      };
      this.$bus.$emit('onRiskInfos', this.data, init);
    },

    //保费试算
    countPremiumSum() {
      this.data.salPolicyHolder.addfifty = '1';
      this.$api.calPremiumEmployer(this.data).then(res => {
        if (res.data.success) {
          let data = res.data.content;
          this.totalPremium = data.totalPremium;
        } else {
          this.$message.error(res.data.returnMsg + '错误');
        }
      });
    },
  },
};
</script>
<style>
#myCals .ant-form-item {
  margin-bottom: 5px !important;
}
.blod .ant-col label {
  font-weight: 600;
}
#myCals .ml20 {
  padding-left: 10px;
}
</style>
<style lang="scss" scoped>
#myCals {
  .policy {
    display: none;
  }
  .redText {
    position: absolute;
    right: -80px;
    color: red;
    top: 16px;
  }
  .calTxt_ {
    font-size: 18px !important;
    font-weight: bold !important;
    color: #666666;
  }
  .pre-box {
    margin-top: 15px;
  }
  .form_items {
    display: flex;
    width: 100%;
    color: #333;
    margin-bottom: 10px;
  }
  .btn_list {
    margin-top: 20px;
    display: flex;

    .calBtn_ {
      margin-right: 30px;
    }
  }
  .flex_ {
    display: flex;
    flex-wrap: wrap;
  }
  .form_item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: #333;
    margin-bottom: 10px !important;

    &.width_50 {
      width: 50%;
    }

    &.width_40 {
      width: 40%;
    }

    &.width_60 {
      width: 60%;
    }

    > label {
      white-space: nowrap;
      margin-right: 10px;
      margin-top: 15px;
    }

    .right_ {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      position: relative;

      .select_ {
        margin-top: 10px;
      }

      .check_item {
        display: flex;
        align-items: center;
        margin-right: 10px;
        margin-top: 10px;

        &.on {
          label {
            border-color: #fe8f2d;
          }
        }

        label {
          // border: 1px solid #d9d9d9;
          padding: 3px 10px;
          border-radius: 3px;
          margin-right: 5px;
        }

        &.s_input input {
          width: 50px;
        }

        input {
          width: 150px;
          margin-right: 5px;
        }
      }
    }
  }
  .p-header {
    width: 100%;
    font-weight: 600;
    font-size: 15px;
    margin-bottom: 0;
  }

  .form_item {
    margin-bottom: 0;
    .ant-form-item {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }
  .aftertext {
    position: relative;
  }
  .aftertext::after {
    content: '500000元起保';
    position: absolute;
    color: #999999;
    top: 10px;
    right: 30px;
    z-index: 2;
  }
  .tiaokuan_list {
    line-height: 24px;
  }
}
</style>